export default __webpack_public_path__ + "static/media/icon_burger.c4c4e54f.svg";